/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AgentTeam = 'SALES' | 'MARKETING' | 'SERVICE' | unhandledEnumCase;

export type AppDependency = {
  appId: number;
  appName: string;
  isInternal: Default<boolean>;
  isPublic: Default<boolean>;
  isUserLevel: Default<boolean>;
};

export type DistributionType = 'MARKETPLACE' | 'PRIVATE' | unhandledEnumCase;

export type ClientApp = 'WORKFLOWS' | 'AGENTS' | unhandledEnumCase;

export type BuilderCompatibility =
  | 'HYBRID_FLOW'
  | 'UNIFIED_BUILDER'
  | unhandledEnumCase;

export namespace ComHubspotAutomationTemplatesCoreApiEnums {
  export type AgentType = 'OFF_PLATFORM' | 'STUDIO' | unhandledEnumCase;
}

export type TemplateAgent = {
  type: ComHubspotAutomationTemplatesCoreApiEnums.AgentType;
  sourceId: string;
};

export const ActionDataIdentifierTypename =
  'com.hubspot.automationplatform.field.core.ActionDataIdentifier';
export const ActionDataIdentifierDiscriminant = 'ACTION';
export const ActionDataIdentifierDiscriminantKey = 'type';
export type ActionDataIdentifier = {
  actionId: number;
  dataKey: string;
  __typename: 'com.hubspot.automationplatform.field.core.ActionDataIdentifier';
} & { type?: 'ACTION' };

export type DataSourceType =
  | 'ENROLLMENT_EVENTS'
  | 'ENROLLMENT_DATASET'
  | 'ENROLLED_OBJECT'
  | 'FETCHED_OBJECTS'
  | 'ACTION_OUTPUTS'
  | 'TRIGGER'
  | 'UNKNOWN'
  | unhandledEnumCase;

export type DelayCountingStrategy = 'BUSINESS_DAYS' | unhandledEnumCase;

export const EnrollmentDataIdentifierTypename =
  'com.hubspot.automationplatform.field.core.EnrollmentDataIdentifier';
export const EnrollmentDataIdentifierDiscriminant = 'ENROLLMENT';
export const EnrollmentDataIdentifierDiscriminantKey = 'type';
export type EnrollmentDataIdentifier = {
  propertyName: string;
  __typename: 'com.hubspot.automationplatform.field.core.EnrollmentDataIdentifier';
} & { type?: 'ENROLLMENT' };

export const FieldDataIdentifierDiscriminantKey = 'type';
export type FieldDataIdentifier =
  | ActionDataIdentifier
  | EnrollmentDataIdentifier;

export type TimeDelay = {
  delta: number;
  timeUnit: Default<ChronoUnit>;
  timeOfDay?: TimeOfDay;
  daysOfWeek: Default<DayOfWeek[]>;
  optionalTimeZoneStrategy?: TimeDelayTimeZoneStrategy;
  delayCountingStrategy?: DelayCountingStrategy;
  weekendStartStrategy?: WeekendStartStrategy;
};

export type TimeDelayTimeZoneStrategy = {
  type: ComHubspotAutomationplatformFieldCoreTimeDelayTimeZoneStrategyIF.Type;
  staticTimeZoneId?: string;
};

export type TimeOfDay = { hour: number; minute: number };

export type WeekendStartStrategy =
  | 'IMMEDIATELY'
  | 'NEXT_BUSINESS_DAY'
  | unhandledEnumCase;

export namespace ComHubspotAutomationplatformFieldCoreTimeDelayTimeZoneStrategyIF {
  export type Type =
    | 'PORTAL'
    | 'ENROLLED_OBJECT'
    | 'STATIC_TIME_ZONE'
    | unhandledEnumCase;
}

export type AllowedCardinality = 'ONE' | 'MANY' | unhandledEnumCase;

export type AllowedMetaType = {
  allowAllObjectTypes: boolean;
  allowedObjectTypes: Default<string[]>;
  blockedObjectTypes: Default<string[]>;
};

export type AllowedObjectTypes = {
  allowAllObjectTypes: boolean;
  metaTypes: Default<Record<string, AllowedMetaType>>;
  fetchAllowedObjectTypesFromOptions: Default<boolean>;
};

export type FieldTypeDefinition = {
  name: string;
  type: ComHubspotContactsDataContactsProtos.Type;
  schema: Default<FieldSchema>;
  label?: string;
  description?: string;
  helpText?: string;
  fieldType?: PropertyFieldType;
  options: Default<Option[]>;
  optionsUrl?: string;
  useChirp: Default<boolean>;
  referencedObjectType?: ObjectType;
  externalOptions: Default<boolean>;
  externalOptionsReferenceType?: string;
};

export type InputFieldDefinition = {
  typeDefinition: FieldTypeDefinition;
  supportedValueTypes?: SupportedValueType[];
  isRequired: Default<boolean>;
  characterLimit?: number;
  includeEmptyIfValueAbsent: Default<boolean>;
  defaultValue?: InputValue;
  automationFieldType?: string;
  allowedObjectTypes?: AllowedObjectTypes;
  allowedCardinality?: AllowedCardinality;
};

export type OutputFieldDefinition = { typeDefinition: FieldTypeDefinition };

export type SupportedValueType =
  | 'STATIC_VALUE'
  | 'OBJECT_PROPERTY'
  | 'FIELD_DATA'
  | 'FETCHED_OBJECT_PROPERTY'
  | 'ACTION_OUTPUT_OBJECT_PROPERTY'
  | 'ENROLLMENT_EVENT_PROPERTY'
  | 'ENROLLMENT_DATASET_COLUMN'
  | 'SINGLE_OBJECT_COORDINATES'
  | unhandledEnumCase;

export const ArrayFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.ArrayFieldSchema';
export const ArrayFieldSchemaDiscriminant = 'ARRAY';
export const ArrayFieldSchemaDiscriminantKey = 'type';
export type ArrayFieldSchema = {
  items: FieldSchema;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.ArrayFieldSchema';
} & { type?: 'ARRAY' };

export const BooleanFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.BooleanFieldSchema';
export const BooleanFieldSchemaDiscriminant = 'BOOLEAN';
export const BooleanFieldSchemaDiscriminantKey = 'type';
export type BooleanFieldSchema = {
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.BooleanFieldSchema';
} & { type?: 'BOOLEAN' };

export const DoubleFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.DoubleFieldSchema';
export const DoubleFieldSchemaDiscriminant = 'DOUBLE';
export const DoubleFieldSchemaDiscriminantKey = 'type';
export type DoubleFieldSchema = {
  minimum?: number;
  maximum?: number;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.DoubleFieldSchema';
} & { type?: 'DOUBLE' };

export const FieldSchemaDiscriminantKey = 'type';
export type FieldSchema =
  | IntegerFieldSchema
  | LongFieldSchema
  | DoubleFieldSchema
  | StringFieldSchema
  | BooleanFieldSchema
  | ArrayFieldSchema
  | ObjectFieldSchema
  | UnknownFieldSchema;

export const IntegerFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.IntegerFieldSchema';
export const IntegerFieldSchemaDiscriminant = 'INTEGER';
export const IntegerFieldSchemaDiscriminantKey = 'type';
export type IntegerFieldSchema = {
  minimum?: number;
  maximum?: number;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.IntegerFieldSchema';
} & { type?: 'INTEGER' };

export const LongFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.LongFieldSchema';
export const LongFieldSchemaDiscriminant = 'LONG';
export const LongFieldSchemaDiscriminantKey = 'type';
export type LongFieldSchema = {
  minimum?: number;
  maximum?: number;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.LongFieldSchema';
} & { type?: 'LONG' };

export const ObjectFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.ObjectFieldSchema';
export const ObjectFieldSchemaDiscriminant = 'OBJECT';
export const ObjectFieldSchemaDiscriminantKey = 'type';
export type ObjectFieldSchema = {
  properties: Default<Record<string, FieldSchema>>;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.ObjectFieldSchema';
} & { type?: 'OBJECT' };

export const StringFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.StringFieldSchema';
export const StringFieldSchemaDiscriminant = 'STRING';
export const StringFieldSchemaDiscriminantKey = 'type';
export type StringFieldSchema = {
  format?: StringFormat;
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.StringFieldSchema';
} & { type?: 'STRING' };

export type StringFormat =
  | 'DATE_TIME'
  | 'TIME'
  | 'DATE'
  | 'URI'
  | 'OBJECT_COORDINATE'
  | 'MONTH_AND_DAY'
  | 'OBJECT_TYPE'
  | unhandledEnumCase;

export const UnknownFieldSchemaTypename =
  'com.hubspot.automationplatform.field.core.definition.schema.UnknownFieldSchema';
export const UnknownFieldSchemaDiscriminant = 'UNKNOWN';
export const UnknownFieldSchemaDiscriminantKey = 'type';
export type UnknownFieldSchema = {
  __typename: 'com.hubspot.automationplatform.field.core.definition.schema.UnknownFieldSchema';
} & { type?: 'UNKNOWN' };

export const ActionOutputObjectPropertyValueTypename =
  'com.hubspot.automationplatform.field.core.input.ActionOutputObjectPropertyValue';
export const ActionOutputObjectPropertyValueDiscriminant =
  'ACTION_OUTPUT_OBJECT_PROPERTY';
export const ActionOutputObjectPropertyValueDiscriminantKey = 'type';
export type ActionOutputObjectPropertyValue = {
  propertyToken: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.ActionOutputObjectPropertyValue';
} & { type?: 'ACTION_OUTPUT_OBJECT_PROPERTY' };

export const AppendObjectPropertyValueTypename =
  'com.hubspot.automationplatform.field.core.input.AppendObjectPropertyValue';
export const AppendObjectPropertyValueDiscriminant = 'APPEND_OBJECT_PROPERTY';
export const AppendObjectPropertyValueDiscriminantKey = 'type';
export type AppendObjectPropertyValue = {
  propertyName: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.AppendObjectPropertyValue';
} & { type?: 'APPEND_OBJECT_PROPERTY' };

export const EnrollmentDatasetColumnValueTypename =
  'com.hubspot.automationplatform.field.core.input.EnrollmentDatasetColumnValue';
export const EnrollmentDatasetColumnValueDiscriminant =
  'ENROLLMENT_DATASET_COLUMN';
export const EnrollmentDatasetColumnValueDiscriminantKey = 'type';
export type EnrollmentDatasetColumnValue = {
  propertyToken: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.EnrollmentDatasetColumnValue';
} & { type?: 'ENROLLMENT_DATASET_COLUMN' };

export const EnrollmentEventPropertyValueTypename =
  'com.hubspot.automationplatform.field.core.input.EnrollmentEventPropertyValue';
export const EnrollmentEventPropertyValueDiscriminant =
  'ENROLLMENT_EVENT_PROPERTY';
export const EnrollmentEventPropertyValueDiscriminantKey = 'type';
export type EnrollmentEventPropertyValue = {
  propertyToken: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.EnrollmentEventPropertyValue';
} & { type?: 'ENROLLMENT_EVENT_PROPERTY' };

export const FetchedObjectPropertyValueTypename =
  'com.hubspot.automationplatform.field.core.input.FetchedObjectPropertyValue';
export const FetchedObjectPropertyValueDiscriminant = 'FETCHED_OBJECT_PROPERTY';
export const FetchedObjectPropertyValueDiscriminantKey = 'type';
export type FetchedObjectPropertyValue = {
  propertyToken: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.FetchedObjectPropertyValue';
} & { type?: 'FETCHED_OBJECT_PROPERTY' };

export const FieldDataValueTypename =
  'com.hubspot.automationplatform.field.core.input.FieldDataValue';
export const FieldDataValueDiscriminant = 'FIELD_DATA';
export const FieldDataValueDiscriminantKey = 'type';
export type FieldDataValue = {
  identifier: FieldDataIdentifier;
  __typename: 'com.hubspot.automationplatform.field.core.input.FieldDataValue';
} & { type?: 'FIELD_DATA' };

export const IncrementValueTypename =
  'com.hubspot.automationplatform.field.core.input.IncrementValue';
export const IncrementValueDiscriminant = 'INCREMENT';
export const IncrementValueDiscriminantKey = 'type';
export type IncrementValue = {
  amount: number;
  __typename: 'com.hubspot.automationplatform.field.core.input.IncrementValue';
} & { type?: 'INCREMENT' };

export const InputValueDiscriminantKey = 'type';
export type InputValue =
  | ObjectPropertyValue
  | TimestampValue
  | StaticValue
  | RelativeDateTimeValue
  | IncrementValue
  | StaticAppendValue
  | AppendObjectPropertyValue
  | FieldDataValue
  | FetchedObjectPropertyValue
  | ActionOutputObjectPropertyValue
  | EnrollmentEventPropertyValue
  | EnrollmentDatasetColumnValue
  | SingleObjectCoordinatesValue
  | MultiValue
  | ListInputValue
  | MapInputValue
  | ObjectCoordinatesProviderValue
  | TemplateValue;

export const ListInputValueTypename =
  'com.hubspot.automationplatform.field.core.input.ListInputValue';
export const ListInputValueDiscriminant = 'LIST_INPUT_VALUE';
export const ListInputValueDiscriminantKey = 'type';
export type ListInputValue = {
  values: Default<InputValue[]>;
  __typename: 'com.hubspot.automationplatform.field.core.input.ListInputValue';
} & { type?: 'LIST_INPUT_VALUE' };

export const MapInputValueTypename =
  'com.hubspot.automationplatform.field.core.input.MapInputValue';
export const MapInputValueDiscriminant = 'MAP_INPUT_VALUE';
export const MapInputValueDiscriminantKey = 'type';
export type MapInputValue = {
  values: Default<Record<string, InputValue>>;
  __typename: 'com.hubspot.automationplatform.field.core.input.MapInputValue';
} & { type?: 'MAP_INPUT_VALUE' };

export const MultiValueTypename =
  'com.hubspot.automationplatform.field.core.input.MultiValue';
export const MultiValueDiscriminant = 'MULTI_VALUE';
export const MultiValueDiscriminantKey = 'type';
export type MultiValue = {
  value: Default<string[]>;
  __typename: 'com.hubspot.automationplatform.field.core.input.MultiValue';
} & { type?: 'MULTI_VALUE' };

export const ObjectCoordinatesProviderValueTypename =
  'com.hubspot.automationplatform.field.core.input.ObjectCoordinatesProviderValue';
export const ObjectCoordinatesProviderValueDiscriminant =
  'OBJECT_COORDINATES_PROVIDER';
export const ObjectCoordinatesProviderValueDiscriminantKey = 'type';
export type ObjectCoordinatesProviderValue = {
  source: DataSourceType;
  sourceId?: number;
  fieldName?: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.ObjectCoordinatesProviderValue';
} & { type?: 'OBJECT_COORDINATES_PROVIDER' };

export const ObjectPropertyValueTypename =
  'com.hubspot.automationplatform.field.core.input.ObjectPropertyValue';
export const ObjectPropertyValueDiscriminant = 'OBJECT_PROPERTY';
export const ObjectPropertyValueDiscriminantKey = 'type';
export type ObjectPropertyValue = {
  propertyName: Default<string>;
  __typename: 'com.hubspot.automationplatform.field.core.input.ObjectPropertyValue';
} & { type?: 'OBJECT_PROPERTY' };

export const RelativeDateTimeValueTypename =
  'com.hubspot.automationplatform.field.core.input.RelativeDateTimeValue';
export const RelativeDateTimeValueDiscriminant = 'RELATIVE_DATETIME';
export const RelativeDateTimeValueDiscriminantKey = 'type';
export type RelativeDateTimeValue = {
  timeDelay: TimeDelay;
  __typename: 'com.hubspot.automationplatform.field.core.input.RelativeDateTimeValue';
} & { type?: 'RELATIVE_DATETIME' };

export const SingleObjectCoordinatesValueTypename =
  'com.hubspot.automationplatform.field.core.input.SingleObjectCoordinatesValue';
export const SingleObjectCoordinatesValueDiscriminant =
  'SINGLE_OBJECT_COORDINATES';
export const SingleObjectCoordinatesValueDiscriminantKey = 'type';
export type SingleObjectCoordinatesValue = {
  coordinatesToken: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.SingleObjectCoordinatesValue';
} & { type?: 'SINGLE_OBJECT_COORDINATES' };

export const StaticAppendValueTypename =
  'com.hubspot.automationplatform.field.core.input.StaticAppendValue';
export const StaticAppendValueDiscriminant = 'STATIC_APPEND_VALUE';
export const StaticAppendValueDiscriminantKey = 'type';
export type StaticAppendValue = {
  value: string;
  __typename: 'com.hubspot.automationplatform.field.core.input.StaticAppendValue';
} & { type?: 'STATIC_APPEND_VALUE' };

export const StaticValueTypename =
  'com.hubspot.automationplatform.field.core.input.StaticValue';
export const StaticValueDiscriminant = 'STATIC_VALUE';
export const StaticValueDiscriminantKey = 'type';
export type StaticValue = {
  value: Default<string>;
  __typename: 'com.hubspot.automationplatform.field.core.input.StaticValue';
} & { type?: 'STATIC_VALUE' };

export const TemplateValueTypename =
  'com.hubspot.automationplatform.field.core.input.TemplateValue';
export const TemplateValueDiscriminant = 'TEMPLATE_VALUE';
export const TemplateValueDiscriminantKey = 'type';
export type TemplateValue = {
  value: Default<string>;
  __typename: 'com.hubspot.automationplatform.field.core.input.TemplateValue';
} & { type?: 'TEMPLATE_VALUE' };

export const TimestampValueTypename =
  'com.hubspot.automationplatform.field.core.input.TimestampValue';
export const TimestampValueDiscriminant = 'TIMESTAMP';
export const TimestampValueDiscriminantKey = 'type';
export type TimestampValue = {
  __typename: 'com.hubspot.automationplatform.field.core.input.TimestampValue';
} & { type?: 'TIMESTAMP' };

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export const BooleanFieldValueTypename =
  'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export type BooleanFieldValue = {
  value: boolean;
  __typename: 'com.hubspot.chirp.ext.models.BooleanFieldValue';
} & { '@type'?: 'boolean' };

export const DoubleFieldValueTypename =
  'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export type DoubleFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.DoubleFieldValue';
} & { '@type'?: 'double' };

export const FloatFieldValueTypename =
  'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export type FloatFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.FloatFieldValue';
} & { '@type'?: 'float' };

export const IntFieldValueTypename =
  'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export type IntFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.IntFieldValue';
} & { '@type'?: 'integer' };

export const ListFieldValueTypename =
  'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export type ListFieldValue = {
  value: Default<ComHubspotChirpExtModels.FieldValue[]>;
  __typename: 'com.hubspot.chirp.ext.models.ListFieldValue';
} & { '@type'?: 'list' };

export const LongFieldValueTypename =
  'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export type LongFieldValue = {
  value: number;
  __typename: 'com.hubspot.chirp.ext.models.LongFieldValue';
} & { '@type'?: 'long' };

export const MapFieldValueTypename =
  'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export type MapFieldValue = {
  value: Default<Record<string, ComHubspotChirpExtModels.FieldValue>>;
  __typename: 'com.hubspot.chirp.ext.models.MapFieldValue';
} & { '@type'?: 'map' };

export const NullFieldValueTypename =
  'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export type NullFieldValue = {
  __typename: 'com.hubspot.chirp.ext.models.NullFieldValue';
} & { '@type'?: 'null' };

export const StringFieldValueTypename =
  'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export type StringFieldValue = {
  value: string;
  __typename: 'com.hubspot.chirp.ext.models.StringFieldValue';
} & { '@type'?: 'string' };

export namespace ComHubspotChirpExtModels {
  export const FieldValueDiscriminantKey = '@type';
  export type FieldValue =
    | NullFieldValue
    | BooleanFieldValue
    | DoubleFieldValue
    | FloatFieldValue
    | IntFieldValue
    | LongFieldValue
    | StringFieldValue
    | ListFieldValue
    | MapFieldValue;
}

export type ObjectType =
  | 'CONTACT'
  | 'COMPANY'
  | 'DEAL'
  | 'ENGAGEMENT'
  | 'TICKET'
  | 'OWNER'
  | 'PRODUCT'
  | 'LINE_ITEM'
  | 'BET_DELIVERABLE_SERVICE'
  | 'CONTENT'
  | 'CONVERSATION'
  | 'BET_ALERT'
  | 'PORTAL'
  | 'QUOTE'
  | 'FORM_SUBMISSION_INBOUNDDB'
  | 'QUOTA'
  | 'UNSUBSCRIBE'
  | 'COMMUNICATION'
  | 'FEEDBACK_SUBMISSION'
  | 'ATTRIBUTION'
  | 'SALESFORCE_SYNC_ERROR'
  | 'RESTORABLE_CRM_OBJECT'
  | 'HUB'
  | 'LANDING_PAGE'
  | 'PRODUCT_OR_FOLDER'
  | 'TASK'
  | 'FORM'
  | 'MARKETING_EMAIL'
  | 'AD_ACCOUNT'
  | 'AD_CAMPAIGN'
  | 'AD_GROUP'
  | 'AD'
  | 'KEYWORD'
  | 'CAMPAIGN'
  | 'SOCIAL_CHANNEL'
  | 'SOCIAL_POST'
  | 'SITE_PAGE'
  | 'BLOG_POST'
  | 'IMPORT'
  | 'EXPORT'
  | 'CTA'
  | 'TASK_TEMPLATE'
  | 'AUTOMATION_PLATFORM_FLOW'
  | 'OBJECT_LIST'
  | 'NOTE'
  | 'MEETING_EVENT'
  | 'CALL'
  | 'EMAIL'
  | 'PUBLISHING_TASK'
  | 'CONVERSATION_SESSION'
  | 'CONTACT_CREATE_ATTRIBUTION'
  | 'INVOICE'
  | 'MARKETING_EVENT'
  | 'CONVERSATION_INBOX'
  | 'CHATFLOW'
  | 'MEDIA_BRIDGE'
  | 'SEQUENCE'
  | 'SEQUENCE_STEP'
  | 'FORECAST'
  | 'SNIPPET'
  | 'TEMPLATE'
  | 'DEAL_CREATE_ATTRIBUTION'
  | 'QUOTE_TEMPLATE'
  | 'QUOTE_MODULE'
  | 'QUOTE_MODULE_FIELD'
  | 'QUOTE_FIELD'
  | 'SEQUENCE_ENROLLMENT'
  | 'SUBSCRIPTION'
  | 'ACCEPTANCE_TEST'
  | 'SOCIAL_BROADCAST'
  | 'DEAL_SPLIT'
  | 'DEAL_REGISTRATION'
  | 'GOAL_TARGET'
  | 'GOAL_TARGET_GROUP'
  | 'PORTAL_OBJECT_SYNC_MESSAGE'
  | 'FILE_MANAGER_FILE'
  | 'FILE_MANAGER_FOLDER'
  | 'SEQUENCE_STEP_ENROLLMENT'
  | 'APPROVAL'
  | 'APPROVAL_STEP'
  | 'CTA_VARIANT'
  | 'SALES_DOCUMENT'
  | 'DISCOUNT'
  | 'FEE'
  | 'TAX'
  | 'MARKETING_CALENDAR'
  | 'PERMISSIONS_TESTING'
  | 'PRIVACY_SCANNER_COOKIE'
  | 'DATA_SYNC_STATE'
  | 'WEB_INTERACTIVE'
  | 'PLAYBOOK'
  | 'FOLDER'
  | 'PLAYBOOK_QUESTION'
  | 'PLAYBOOK_SUBMISSION'
  | 'PLAYBOOK_SUBMISSION_ANSWER'
  | 'COMMERCE_PAYMENT'
  | 'GSC_PROPERTY'
  | 'SOX_PROTECTED_DUMMY_TYPE'
  | 'BLOG_LISTING_PAGE'
  | 'QUARANTINED_SUBMISSION'
  | 'PAYMENT_SCHEDULE'
  | 'PAYMENT_SCHEDULE_INSTALLMENT'
  | 'MARKETING_CAMPAIGN_UTM'
  | 'DISCOUNT_TEMPLATE'
  | 'DISCOUNT_CODE'
  | 'FEEDBACK_SURVEY'
  | 'CMS_URL'
  | 'SALES_TASK'
  | 'SALES_WORKLOAD'
  | 'USER'
  | 'POSTAL_MAIL'
  | 'SCHEMAS_BACKEND_TEST'
  | 'PAYMENT_LINK'
  | 'SUBMISSION_TAG'
  | 'CAMPAIGN_STEP'
  | 'SCHEDULING_PAGE'
  | 'SOX_PROTECTED_TEST_TYPE'
  | 'ORDER'
  | 'MARKETING_SMS'
  | 'PARTNER_ACCOUNT'
  | 'CAMPAIGN_TEMPLATE'
  | 'CAMPAIGN_TEMPLATE_STEP'
  | 'PLAYLIST'
  | 'CLIP'
  | 'CAMPAIGN_BUDGET_ITEM'
  | 'CAMPAIGN_SPEND_ITEM'
  | 'MIC'
  | 'CONTENT_AUDIT'
  | 'CONTENT_AUDIT_PAGE'
  | 'PLAYLIST_FOLDER'
  | 'LEAD'
  | 'ABANDONED_CART'
  | 'EXTERNAL_WEB_URL'
  | 'VIEW'
  | 'VIEW_BLOCK'
  | 'ROSTER'
  | 'CART'
  | 'AUTOMATION_PLATFORM_FLOW_ACTION'
  | 'SOCIAL_PROFILE'
  | 'PARTNER_CLIENT'
  | 'ROSTER_MEMBER'
  | 'MARKETING_EVENT_ATTENDANCE'
  | 'ALL_PAGES'
  | 'AI_FORECAST'
  | 'CRM_PIPELINES_DUMMY_TYPE'
  | 'KNOWLEDGE_ARTICLE'
  | 'PROPERTY_INFO'
  | 'DATA_PRIVACY_CONSENT'
  | 'GOAL_TEMPLATE'
  | 'SCORE_CONFIGURATION'
  | 'AUDIENCE'
  | 'PARTNER_CLIENT_REVENUE'
  | 'AUTOMATION_JOURNEY'
  | 'COMBO_EVENT_CONFIGURATION'
  | 'CRM_OBJECTS_DUMMY_TYPE'
  | 'CASE_STUDY'
  | 'SERVICE'
  | 'PODCAST_EPISODE'
  | 'PARTNER_SERVICE'
  | 'PROSPECTING_AGENT_CONTACT_ASSIGNMENT'
  | 'UNKNOWN'
  | unhandledEnumCase;

export type Option = {
  hidden?: boolean;
  displayOrder?: number;
  doubleData?: number;
  description?: string;
  readOnly?: boolean;
  label?: string;
  value?: string;
};

export namespace ComHubspotContactsDataContactsProtos {
  export type Type =
    | 'string'
    | 'number'
    | 'bool'
    | 'datetime'
    | 'enumeration'
    | 'date'
    | 'phone_number'
    | 'currency_number'
    | 'json'
    | 'object_coordinates'
    | 'time_range'
    | unhandledEnumCase;
}

export type CredentialType =
  | 'BADGE'
  | 'CERTIFICATION'
  | 'ACCREDITATION'
  | unhandledEnumCase;

export type GranteeEntity =
  | 'USER'
  | 'PORTAL'
  | 'APP'
  | 'ASSET'
  | 'PARTNER'
  | unhandledEnumCase;

export type Topic =
  | 'NO_TOPIC'
  | 'GENERAL'
  | 'ACADEMY'
  | 'COMMUNITY'
  | 'MARKETPLACE'
  | 'PARTNER_MARKETING'
  | 'CONNECT'
  | unhandledEnumCase;

export type PreviewImage = { id: number; url: string; altText?: string };

export type EligibleLocation =
  | 'CRM_RECORD_TAB'
  | 'CRM_RECORD_SIDEBAR'
  | 'CRM_PREVIEW'
  | 'HELPDESK_SIDEBAR'
  | 'SETTINGS'
  | 'APP_HOME'
  | unhandledEnumCase;

export type DefaultTierPointsCreditedTierOption =
  | 'diamond'
  | 'elite'
  | 'gold'
  | 'none'
  | 'platinum'
  | unhandledEnumCase;

export type DefaultTypeOption =
  | 'directory_user'
  | 'partner'
  | 'provider'
  | unhandledEnumCase;

export type BoxManagementType =
  | 'HS_KAAS'
  | 'HS_OTHER'
  | 'USER'
  | unhandledEnumCase;

export type DraftListingRequest = { listingId: number; language?: string };

export type EditorDetailsError = {
  message: string;
  type: EditorDetailsErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type EditorDetailsResponse = {
  detailsByListingId: Default<Record<string, ListingAndEntries>>;
  productVersionsById: Default<Record<string, ProductVersion>>;
};

export type EditorListingSummaryPageResponse = {
  productVersionsById: Default<Record<string, ProductVersion>>;
  results: Default<ListingSummary[]>;
  hasMore: boolean;
  offset: ListingCursor;
};

export type EditorListingSummaryResponse = {
  summariesByListingId: Default<Record<string, ListingSummary>>;
  productVersionsById: Default<Record<string, ProductVersion>>;
};

export type EntrySummary = {
  fieldsByKey: Default<
    Record<string, ComHubspotMarketplaceSchemataModelsEntries.FieldValue>
  >;
};

export type GetListingSummariesPageRequest = {
  entryKeys: Default<string[]>;
  offset: Default<ListingCursor>;
  pageLength: Default<number>;
};

export type GetListingSummariesRequest = { entryKeys: Default<string[]> };

export type ListingAndEntries = {
  entriesById: Default<Record<string, BatchEntry>>;
  listing: Listing;
  installCount?: number;
  reviewStats?: OverallStats;
};

export type ListingSummary = {
  listing: Listing;
  displayFieldsByEntryId: Default<Record<string, EntrySummary>>;
  installCount?: number;
};

export type EditorDetailsErrorType =
  | 'UNAUTHORIZED'
  | 'LISTING_NOT_FOUND'
  | 'INTERNAL_ERROR'
  | unhandledEnumCase;

export type ListingDetailsResponseV3 = {
  listing: ComHubspotChirpExtModels.FieldValue;
  listingLanguage?: string;
};

export type Listing = {
  id: number;
  createdAt: number;
  createdByUserId: number;
  portalId: number;
  primaryLanguage: string;
  legacyOfferingId?: number;
  profileId?: number;
  properties: ListingProperties;
  versions: Default<ListingVersion[]>;
};

export type ListingProperties = {
  firstPublishedAt?: number;
  certifiedAt?: number;
  publishedSlug?: string;
  publishedName?: string;
  lastPublishedAt?: number;
  lastUnpublishedAt?: number;
};

export type ListingVersion = {
  id: number;
  listingId: number;
  createdAt: number;
  createdByUserId: number;
  language: string;
  state: ListingVersionState;
  stateUpdatedAt: number;
  productGroup: ListingProductGroup;
  entryId: number;
  entryUpdatedAt: number;
  legacyListingId?: number;
  entryUpdatedBy?: number;
  version: Default<number>;
};

export type ListingVersionState =
  | 'DRAFT'
  | 'PENDING_APPROVAL'
  | 'PUBLISHED'
  | 'PENDING_UNPUBLICATION'
  | unhandledEnumCase;

export type ListingProduct = {
  listingVersionId: number;
  productId: number;
  productVersionId: number;
  productType: ComHubspotMarketplaceProductsModelsProductsJdk17.ProductType;
  sourceId: string;
};

export type ListingProductGroup = { products: Default<ListingProduct[]> };

export type ListingCursor = { afterId: Default<number> };

export const ActionTypeIconTypename =
  'com.hubspot.marketplace.products.models.features.ActionTypeIcon';
export const ActionTypeIconDiscriminant = 'ACTION_TYPE';
export const ActionTypeIconDiscriminantKey = 'type';
export type ActionTypeIcon = {
  actionType: string;
  __typename: 'com.hubspot.marketplace.products.models.features.ActionTypeIcon';
} & { type?: 'ACTION_TYPE' };

export const AppIconTypename =
  'com.hubspot.marketplace.products.models.features.AppIcon';
export const AppIconDiscriminant = 'APP';
export const AppIconDiscriminantKey = 'type';
export type AppIcon = {
  appId: number;
  __typename: 'com.hubspot.marketplace.products.models.features.AppIcon';
} & { type?: 'APP' };

export const AppObjectDataTypename =
  'com.hubspot.marketplace.products.models.features.AppObjectData';
export const AppObjectDataDiscriminant = 'APP_OBJECT';
export const AppObjectDataDiscriminantKey = 'type';
export type AppObjectData = {
  description?: string;
  singularForm?: string;
  pluralForm?: string;
  primaryDisplayLabelPropertyName?: string;
  secondaryDisplayLabelPropertyNames: Default<string[]>;
  createdAt: number;
  updatedAt: number;
  __typename: 'com.hubspot.marketplace.products.models.features.AppObjectData';
} & { type?: 'APP_OBJECT' };

export const ChirpRpcDataTypename =
  'com.hubspot.marketplace.products.models.features.ChirpRpcData';
export const ChirpRpcDataDiscriminant = 'CHIRP_RPC';
export const ChirpRpcDataDiscriminantKey = 'type';
export type ChirpRpcData = {
  fqn: string;
  method: string;
  scopes: Default<string[]>;
  createdAt: number;
  updatedAt: number;
  __typename: 'com.hubspot.marketplace.products.models.features.ChirpRpcData';
} & { type?: 'CHIRP_RPC' };

export type Feature = {
  id: number;
  type: ComHubspotMarketplaceProductsModelsFeatures.FeatureType;
  sourceId: string;
  name: string;
  data: FeatureData;
};

export const FeatureDataDiscriminantKey = 'type';
export type FeatureData =
  | WorkflowActionData
  | UIEData
  | KnowledgeBoxData
  | McpServerData
  | StudioAgentFeatureData
  | ChirpRpcData
  | AppObjectData
  | OffPlatformAgentFeatureData
  | WorkflowTriggerData;

export const KnowledgeBoxDataTypename =
  'com.hubspot.marketplace.products.models.features.KnowledgeBoxData';
export const KnowledgeBoxDataDiscriminant = 'KNOWLEDGE_BOX';
export const KnowledgeBoxDataDiscriminantKey = 'type';
export type KnowledgeBoxData = {
  description?: string;
  scopes: Default<string[]>;
  managementType: BoxManagementType;
  createdAt: number;
  updatedAt: number;
  __typename: 'com.hubspot.marketplace.products.models.features.KnowledgeBoxData';
} & { type?: 'KNOWLEDGE_BOX' };

export const McpServerDataTypename =
  'com.hubspot.marketplace.products.models.features.McpServerData';
export const McpServerDataDiscriminant = 'MCP_SERVER';
export const McpServerDataDiscriminantKey = 'type';
export type McpServerData = {
  description?: string;
  enabled?: boolean;
  scopes: Default<string[]>;
  visibility?: McpServerVisibility;
  createdAt: number;
  updatedAt: number;
  __typename: 'com.hubspot.marketplace.products.models.features.McpServerData';
} & { type?: 'MCP_SERVER' };

export const OffPlatformAgentFeatureDataTypename =
  'com.hubspot.marketplace.products.models.features.OffPlatformAgentFeatureData';
export const OffPlatformAgentFeatureDataDiscriminant =
  'OFF_PLATFORM_AGENT_FEATURE';
export const OffPlatformAgentFeatureDataDiscriminantKey = 'type';
export type OffPlatformAgentFeatureData = {
  nameByLanguage: Default<Record<string, string>>;
  scopes: Default<string[]>;
  createdAt: number;
  updatedAt: number;
  __typename: 'com.hubspot.marketplace.products.models.features.OffPlatformAgentFeatureData';
} & { type?: 'OFF_PLATFORM_AGENT_FEATURE' };

export const StudioAgentFeatureDataTypename =
  'com.hubspot.marketplace.products.models.features.StudioAgentFeatureData';
export const StudioAgentFeatureDataDiscriminant = 'STUDIO_AGENT';
export const StudioAgentFeatureDataDiscriminantKey = 'type';
export type StudioAgentFeatureData = {
  description?: string;
  iconUrl?: string;
  authorName?: string;
  scopes: Default<string[]>;
  createdAt: number;
  updatedAt: number;
  __typename: 'com.hubspot.marketplace.products.models.features.StudioAgentFeatureData';
} & { type?: 'STUDIO_AGENT' };

export const UIEDataTypename =
  'com.hubspot.marketplace.products.models.features.UIEData';
export const UIEDataDiscriminant = 'UIE';
export const UIEDataDiscriminantKey = 'type';
export type UIEData = {
  initiatingUserId: number;
  description?: string;
  previewImage?: PreviewImage;
  eligibleLocations: Default<EligibleLocation[]>;
  createdAt: number;
  updatedAt: number;
  __typename: 'com.hubspot.marketplace.products.models.features.UIEData';
} & { type?: 'UIE' };

export const WorkflowActionDataTypename =
  'com.hubspot.marketplace.products.models.features.WorkflowActionData';
export const WorkflowActionDataDiscriminant = 'WORKFLOW_ACTION';
export const WorkflowActionDataDiscriminantKey = 'type';
export type WorkflowActionData = {
  actionTypeId: string;
  objectTypes: Default<string[]>;
  inputFields: Default<InputFieldDefinition[]>;
  outputFields: Default<OutputFieldDefinition[]>;
  actionNameByLanguage: Default<Record<string, string>>;
  scopes: Default<string[]>;
  isTool?: boolean;
  supportedClients: Default<ClientApp[]>;
  icon?: WorkflowActionIcon;
  orderIndex?: number;
  createdAt: number;
  updatedAt: number;
  __typename: 'com.hubspot.marketplace.products.models.features.WorkflowActionData';
} & { type?: 'WORKFLOW_ACTION' };

export const WorkflowActionIconDiscriminantKey = 'type';
export type WorkflowActionIcon = ActionTypeIcon | AppIcon;

export const WorkflowTriggerDataTypename =
  'com.hubspot.marketplace.products.models.features.WorkflowTriggerData';
export const WorkflowTriggerDataDiscriminant = 'WORKFLOW_TRIGGER';
export const WorkflowTriggerDataDiscriminantKey = 'type';
export type WorkflowTriggerData = {
  triggerTypeId: string;
  label: string;
  icon?: WorkflowActionIcon;
  createdAt: number;
  updatedAt: number;
  __typename: 'com.hubspot.marketplace.products.models.features.WorkflowTriggerData';
} & { type?: 'WORKFLOW_TRIGGER' };

export namespace ComHubspotMarketplaceProductsModelsFeatures {
  export type FeatureType =
    | 'WORKFLOW_ACTION'
    | 'UIE'
    | 'KNOWLEDGE_BOX'
    | 'MCP_SERVER'
    | 'STUDIO_AGENT'
    | 'CHIRP_RPC'
    | 'APP_OBJECT'
    | 'OFF_PLATFORM_AGENT_FEATURE'
    | 'WORKFLOW_TRIGGER'
    | unhandledEnumCase;
}

export const AgentDataTypename =
  'com.hubspot.marketplace.products.models.products.AgentData';
export const AgentDataDiscriminant = 'AGENT';
export const AgentDataDiscriminantKey = 'type';
export type AgentData = {
  agentType: ComHubspotMarketplaceProductsModelsProductsAgents.AgentType;
  agentTeam?: AgentTeam;
  description?: string;
  iconUrl?: string;
  authorName?: string;
  scopes: Default<string[]>;
  appDependencies: Default<AppDependency[]>;
  ubbInfo?: UbbInfo;
  derivedScopes: Default<string[]>;
  builtByHubSpot: boolean;
  lastUpdatedAt: number;
  lastUpdatedBy?: number;
  __typename: 'com.hubspot.marketplace.products.models.products.AgentData';
} & { type?: 'AGENT' };

export const AgentVersionDataTypename =
  'com.hubspot.marketplace.products.models.products.AgentVersionData';
export const AgentVersionDataDiscriminant = 'AGENT';
export const AgentVersionDataDiscriminantKey = 'type';
export type AgentVersionData = {
  /** @deprecated */
  scopes: Default<string[]>;
  __typename: 'com.hubspot.marketplace.products.models.products.AgentVersionData';
} & { type?: 'AGENT' };

export const AppDataTypename =
  'com.hubspot.marketplace.products.models.products.AppData';
export const AppDataDiscriminant = 'APP';
export const AppDataDiscriminantKey = 'type';
export type AppData = {
  certifiedAt?: number;
  redirectUrls: Default<string[]>;
  scopeGroups: Default<string[]>;
  additionalScopeGroups: Default<string[]>;
  optionalScopeGroups: Default<string[]>;
  iconUrl?: string;
  connectionType?: ConnectionType;
  isOpsHub?: boolean;
  isDashworks?: boolean;
  isMcpConnector?: boolean;
  isMcpServer?: boolean;
  isBreezeConnector?: boolean;
  distribution?: DistributionType;
  isUserLevel?: boolean;
  projectId?: number;
  builtByHubSpot: boolean;
  lastUpdatedAt: number;
  lastUpdatedBy?: number;
  __typename: 'com.hubspot.marketplace.products.models.products.AppData';
} & { type?: 'APP' };

export type AppReleaseInfo = { releaseTag: string; releaseNotes?: string };

export const AppVersionDataTypename =
  'com.hubspot.marketplace.products.models.products.AppVersionData';
export const AppVersionDataDiscriminant = 'APP';
export const AppVersionDataDiscriminantKey = 'type';
export type AppVersionData = {
  /** @deprecated */
  iconUrl?: string;
  /** @deprecated */
  connectionType?: ConnectionType;
  scopeGroups: Default<string[]>;
  additionalScopeGroups: Default<string[]>;
  optionalScopeGroups: Default<string[]>;
  releaseInfo?: AppReleaseInfo;
  __typename: 'com.hubspot.marketplace.products.models.products.AppVersionData';
} & { type?: 'APP' };

export const ModuleDataTypename =
  'com.hubspot.marketplace.products.models.products.ModuleData';
export const ModuleDataDiscriminant = 'MODULE';
export const ModuleDataDiscriminantKey = 'type';
export type ModuleData = {
  builtByHubSpot: boolean;
  lastUpdatedAt: number;
  lastUpdatedBy?: number;
  __typename: 'com.hubspot.marketplace.products.models.products.ModuleData';
} & { type?: 'MODULE' };

export const ModuleVersionDataTypename =
  'com.hubspot.marketplace.products.models.products.ModuleVersionData';
export const ModuleVersionDataDiscriminant = 'MODULE';
export const ModuleVersionDataDiscriminantKey = 'type';
export type ModuleVersionData = {
  __typename: 'com.hubspot.marketplace.products.models.products.ModuleVersionData';
} & { type?: 'MODULE' };

export const ProductDataDiscriminantKey = 'type';
export type ProductData =
  | AppData
  | ThemeData
  | ModuleData
  | AgentData
  | SolutionsPartnerProfileData
  | WorkflowTemplateData;

export type ProductDisplayTag =
  | 'APP'
  | 'AGENT'
  | 'ASSISTANT'
  | 'CONNECTOR'
  | 'SOLUTIONS_PARTNER'
  | 'WORKFLOW_TEMPLATE'
  | 'FEATURED_AGENT'
  | 'AGENT_TEMPLATE'
  | unhandledEnumCase;

export type ProductVersion = {
  id: number;
  productId: number;
  portalId: number;
  type: ComHubspotMarketplaceProductsModelsProducts.ProductType;
  sourceId: string;
  name: string;
  productData: ProductData;
  data: ProductVersionData;
  displayTag?: ProductDisplayTag;
  createdAt: number;
  updatedAt: number;
  lockedAt?: number;
  features: Default<Feature[]>;
};

export const ProductVersionDataDiscriminantKey = 'type';
export type ProductVersionData =
  | AppVersionData
  | ThemeVersionData
  | ModuleVersionData
  | AgentVersionData
  | SolutionsPartnerProfileVersionData
  | WorkflowTemplateVersionData;

export const SolutionsPartnerProfileDataTypename =
  'com.hubspot.marketplace.products.models.products.SolutionsPartnerProfileData';
export const SolutionsPartnerProfileDataDiscriminant =
  'SOLUTIONS_PARTNER_PROFILE';
export const SolutionsPartnerProfileDataDiscriminantKey = 'type';
export type SolutionsPartnerProfileData = {
  crmObjectId?: number;
  tier?: DefaultTierPointsCreditedTierOption;
  credentials: Default<ProfileCredential[]>;
  partnerType?: DefaultTypeOption;
  builtByHubSpot: Default<boolean>;
  lastUpdatedAt: number;
  lastUpdatedBy?: number;
  __typename: 'com.hubspot.marketplace.products.models.products.SolutionsPartnerProfileData';
} & { type?: 'SOLUTIONS_PARTNER_PROFILE' };

export const SolutionsPartnerProfileVersionDataTypename =
  'com.hubspot.marketplace.products.models.products.SolutionsPartnerProfileVersionData';
export const SolutionsPartnerProfileVersionDataDiscriminant =
  'SOLUTIONS_PARTNER_PROFILE';
export const SolutionsPartnerProfileVersionDataDiscriminantKey = 'type';
export type SolutionsPartnerProfileVersionData = {
  __typename: 'com.hubspot.marketplace.products.models.products.SolutionsPartnerProfileVersionData';
} & { type?: 'SOLUTIONS_PARTNER_PROFILE' };

export const ThemeDataTypename =
  'com.hubspot.marketplace.products.models.products.ThemeData';
export const ThemeDataDiscriminant = 'THEME';
export const ThemeDataDiscriminantKey = 'type';
export type ThemeData = {
  builtByHubSpot: boolean;
  lastUpdatedAt: number;
  lastUpdatedBy?: number;
  __typename: 'com.hubspot.marketplace.products.models.products.ThemeData';
} & { type?: 'THEME' };

export const ThemeVersionDataTypename =
  'com.hubspot.marketplace.products.models.products.ThemeVersionData';
export const ThemeVersionDataDiscriminant = 'THEME';
export const ThemeVersionDataDiscriminantKey = 'type';
export type ThemeVersionData = {
  __typename: 'com.hubspot.marketplace.products.models.products.ThemeVersionData';
} & { type?: 'THEME' };

export type UBBKey = {
  featureGroup: FeatureGroup;
  featureType: ComHubspotUsagebasedbillingCommonsModels.FeatureType;
};

export type UbbCostDetails = {
  metric: BillableMetricType;
  label: string;
  cost: number;
};

export type UbbInfo = {
  key?: UBBKey;
  costDetails: Default<UbbCostDetails[]>;
  tempStandinCost?: number;
};

export const WorkflowTemplateDataTypename =
  'com.hubspot.marketplace.products.models.products.WorkflowTemplateData';
export const WorkflowTemplateDataDiscriminant = 'WORKFLOW_TEMPLATE';
export const WorkflowTemplateDataDiscriminantKey = 'type';
export type WorkflowTemplateData = {
  gate?: string;
  owningTeam?: string;
  compatibleBuilders: Default<BuilderCompatibility[]>;
  /** @deprecated */
  scopes: Default<string[]>;
  builtByHubSpot: Default<boolean>;
  lastUpdatedAt: number;
  lastUpdatedBy?: number;
  __typename: 'com.hubspot.marketplace.products.models.products.WorkflowTemplateData';
} & { type?: 'WORKFLOW_TEMPLATE' };

export const WorkflowTemplateVersionDataTypename =
  'com.hubspot.marketplace.products.models.products.WorkflowTemplateVersionData';
export const WorkflowTemplateVersionDataDiscriminant = 'WORKFLOW_TEMPLATE';
export const WorkflowTemplateVersionDataDiscriminantKey = 'type';
export type WorkflowTemplateVersionData = {
  flowId?: number;
  version?: number;
  url?: string;
  requiredScopes: Default<string[]>;
  actionCount?: number;
  /** @deprecated */
  workflowActionTypeIds: Default<string[]>;
  workflowActionTypes: Default<string[]>;
  requiredAppIds: Default<number[]>;
  requiredAgents: Default<TemplateAgent[]>;
  __typename: 'com.hubspot.marketplace.products.models.products.WorkflowTemplateVersionData';
} & { type?: 'WORKFLOW_TEMPLATE' };

export namespace ComHubspotMarketplaceProductsModelsProducts {
  export type ProductType =
    | 'APP'
    | 'THEME'
    | 'MODULE'
    | 'AGENT'
    | 'SOLUTIONS_PARTNER_PROFILE'
    | 'WORKFLOW_TEMPLATE'
    | unhandledEnumCase;
}

export namespace ComHubspotMarketplaceProductsModelsProductsAgents {
  export type AgentType =
    | 'STUDIO'
    | 'ASSISTANT'
    | 'OFF_PLATFORM'
    | unhandledEnumCase;
}

export type ConnectionType =
  | 'STANDARD'
  | 'HOMEMADE_IFRAME'
  | 'HOMEMADE_EXTERNAL'
  | 'HOMEMADE_MODAL'
  | 'HOMEMADE_PREINSTALLED'
  | 'HOMEMADE_UNIFIED_ACCOUNT'
  | unhandledEnumCase;

export namespace ComHubspotMarketplaceProductsModelsProductsJdk17 {
  export type ProductType =
    | 'APP'
    | 'THEME'
    | 'MODULE'
    | 'AGENT'
    | 'SOLUTIONS_PARTNER_PROFILE'
    | 'WORKFLOW_TEMPLATE'
    | unhandledEnumCase;
}

export type ProfileCredential = {
  id: number;
  internalName: string;
  topic: Topic;
  type: CredentialType;
  granteeEntity?: GranteeEntity;
  enabled: Default<boolean>;
  slug?: string;
  icon?: string;
  localizedDisplays: Default<Record<string, ProfileCredentialDisplay>>;
};

export type ProfileCredentialDisplay = { title: string; description: string };

export const ArrayValueTypename =
  'com.hubspot.marketplace.schemata.models.entries.ArrayValue';
export const ArrayValueDiscriminant = 'ARRAY';
export const ArrayValueDiscriminantKey = 'type';
export type ArrayValue = {
  values: Default<ComHubspotMarketplaceSchemataModelsEntries.FieldValue[]>;
  matchArray: Default<boolean>;
  id: number;
  key: string;
  match?: MatchAttempt;
  fingerprint?: string;
  createdAt: Default<number>;
  /** @deprecated */
  updatedAt: Default<number>;
  __typename: 'com.hubspot.marketplace.schemata.models.entries.ArrayValue';
} & { type?: 'ARRAY' };

export const ChoiceValueTypename =
  'com.hubspot.marketplace.schemata.models.entries.ChoiceValue';
export const ChoiceValueDiscriminant = 'CHOICE';
export const ChoiceValueDiscriminantKey = 'type';
export type ChoiceValue = {
  chosen: Default<string[]>;
  conditionalValues: Default<
    ComHubspotMarketplaceSchemataModelsEntries.FieldValue[]
  >;
  id: number;
  key: string;
  match?: MatchAttempt;
  fingerprint?: string;
  createdAt: Default<number>;
  /** @deprecated */
  updatedAt: Default<number>;
  __typename: 'com.hubspot.marketplace.schemata.models.entries.ChoiceValue';
} & { type?: 'CHOICE' };

export const GroupValueTypename =
  'com.hubspot.marketplace.schemata.models.entries.GroupValue';
export const GroupValueDiscriminant = 'GROUP';
export const GroupValueDiscriminantKey = 'type';
export type GroupValue = {
  values: Default<ComHubspotMarketplaceSchemataModelsEntries.FieldValue[]>;
  id: number;
  key: string;
  match?: MatchAttempt;
  fingerprint?: string;
  createdAt: Default<number>;
  /** @deprecated */
  updatedAt: Default<number>;
  __typename: 'com.hubspot.marketplace.schemata.models.entries.GroupValue';
} & { type?: 'GROUP' };

export type LocalizedLocationValue = {
  full: string;
  country: string;
  locality?: string;
  streetLine1?: string;
  streetLine2?: string;
  state?: string;
  zip?: string;
  /** @deprecated */
  updatedAt: Default<number>;
};

export type LocalizedMediaValue = {
  value: string;
  altText: string;
  /** @deprecated */
  updatedAt: Default<number>;
};

export type LocalizedStringValue = {
  value: string;
  /** @deprecated */
  updatedAt: Default<number>;
};

export const LocationValueTypename =
  'com.hubspot.marketplace.schemata.models.entries.LocationValue';
export const LocationValueDiscriminant = 'LOCATION';
export const LocationValueDiscriminantKey = 'type';
export type LocationValue = {
  full: Default<string>;
  country: Default<string>;
  locality?: string;
  streetLine1?: string;
  streetLine2?: string;
  state?: string;
  zip?: string;
  /** @deprecated */
  localizedValues: Default<Record<string, LocalizedLocationValue>>;
  id: number;
  key: string;
  match?: MatchAttempt;
  fingerprint?: string;
  createdAt: Default<number>;
  /** @deprecated */
  updatedAt: Default<number>;
  __typename: 'com.hubspot.marketplace.schemata.models.entries.LocationValue';
} & { type?: 'LOCATION' };

export const LongValueTypename =
  'com.hubspot.marketplace.schemata.models.entries.LongValue';
export const LongValueDiscriminant = 'LONG';
export const LongValueDiscriminantKey = 'type';
export type LongValue = {
  value?: number;
  id: number;
  key: string;
  match?: MatchAttempt;
  fingerprint?: string;
  createdAt: Default<number>;
  /** @deprecated */
  updatedAt: Default<number>;
  __typename: 'com.hubspot.marketplace.schemata.models.entries.LongValue';
} & { type?: 'LONG' };

export const MediaValueTypename =
  'com.hubspot.marketplace.schemata.models.entries.MediaValue';
export const MediaValueDiscriminant = 'MEDIA';
export const MediaValueDiscriminantKey = 'type';
export type MediaValue = {
  value: Default<string>;
  altText: Default<string>;
  /** @deprecated */
  localizedValues: Default<Record<string, LocalizedMediaValue>>;
  id: number;
  key: string;
  match?: MatchAttempt;
  fingerprint?: string;
  createdAt: Default<number>;
  /** @deprecated */
  updatedAt: Default<number>;
  __typename: 'com.hubspot.marketplace.schemata.models.entries.MediaValue';
} & { type?: 'MEDIA' };

export const StringValueTypename =
  'com.hubspot.marketplace.schemata.models.entries.StringValue';
export const StringValueDiscriminant = 'STRING';
export const StringValueDiscriminantKey = 'type';
export type StringValue = {
  value: Default<string>;
  /** @deprecated */
  localizedValues: Default<Record<string, LocalizedStringValue>>;
  id: number;
  key: string;
  match?: MatchAttempt;
  fingerprint?: string;
  createdAt: Default<number>;
  /** @deprecated */
  updatedAt: Default<number>;
  __typename: 'com.hubspot.marketplace.schemata.models.entries.StringValue';
} & { type?: 'STRING' };

export namespace ComHubspotMarketplaceSchemataModelsEntries {
  export const FieldValueDiscriminantKey = 'type';
  export type FieldValue =
    | StringValue
    | LongValue
    | MediaValue
    | ChoiceValue
    | LocationValue
    | GroupValue
    | ArrayValue;
}

export type Match = { type: string; id?: string; subMatch?: Match };

export type MatchAction =
  | 'SHOW'
  | 'SHOW_FOR_EACH'
  | 'HIDE'
  | 'DELETE'
  | 'FREEZE'
  | unhandledEnumCase;

export type MatchAttempt = { matches: Default<Match[]>; action: MatchAction };

export type MetaInfo = { info: Default<Record<string, MetaTypeInfo[]>> };

export type MetaTypeInfo = {
  id?: string;
  subTypeInfo: Default<Record<string, MetaTypeInfo[]>>;
};

export type BatchEntry = {
  language: string;
  rootValues: Default<ComHubspotMarketplaceSchemataModelsEntries.FieldValue[]>;
  entryId: number;
  locked: boolean;
  primaryLanguage: string;
  metaInfo: MetaInfo;
  schemaId?: number;
  namespace: string;
  version: number;
};

export type PropertyFieldType =
  | 'booleancheckbox'
  | 'checkbox'
  | 'date'
  | 'file'
  | 'number'
  | 'phonenumber'
  | 'radio'
  | 'select'
  | 'text'
  | 'textarea'
  | 'calculation_equation'
  | 'calculation_rollup'
  | 'calculation_score'
  | 'calculation_read_time'
  | 'unknown'
  | 'html'
  | unhandledEnumCase;

export type OverallStats = {
  count: number;
  average?: number;
  adjustedAverage?: number;
  distribution: Default<Record<string, number>>;
};

export type BillableMetricType =
  | 'BREEZE_CONTACT_ENRICHMENT'
  | 'BREEZE_COMPANY_ENRICHMENT'
  | 'BREEZE_SMART_PROPERTY'
  | 'CUSTOMER_AGENT_TEXT_CONVERSATION'
  | 'CUSTOMER_AGENT_TEXT_CONVERSATION_RESOLUTION'
  | 'PROSPECTING_AGENT_CONTACT_MONITORING'
  | 'PROSPECTING_AGENT_COMPANY_RESEARCH'
  | 'PROSPECTING_AGENT_CONTACT_OUTREACH'
  | 'DATA_AGENT_PROMPT_RESPONSE'
  | 'CLOSING_AGENT_CONVERSATION'
  | 'WORKFLOWS_BREEZE_ACTION'
  | 'INTENT_MONITORING'
  | 'DATA_HUB_SMALL_SYNC'
  | 'DATA_HUB_MEDIUM_SYNC'
  | 'DATA_HUB_LARGE_SYNC'
  | 'WHATSAPP_MESSAGE_SENT'
  | 'EMAIL_SEND'
  | 'QUOTE_ACCEPTED'
  | 'CALLING_MINUTES'
  | 'WORKFLOWS_NON_AI_ACTION'
  | 'CUSTOM_EVENTS'
  | 'AEO_RECOMMENDATION_ACTION'
  | 'MARKETS_COMPANY_ADD'
  | 'CUSTOM_INTENT_SIGNAL'
  | 'KNOWLEDGE_BASE_AGENT_GENERATE_ARTICLE'
  | 'CUSTOM_AGENT_GPT_5_4'
  | 'AEO_PROMPT_EXECUTION'
  | 'NURTURE_AGENT_EMAIL_PERSONALIZATION'
  | 'CAMPAIGN_AGENT_PLAN_RECOMMENDATION'
  | 'REVENUE_AGENT_PAYMENT_COLLECTION_OUTREACH'
  | 'CUSTOMER_AGENT_VOICE_CONVERSATION'
  | 'WORK_AGENT_USE_1_ACTION_UNIT'
  | 'CONVERSATIONAL_CONTEXT_RECORD_ANALYSIS'
  | 'TEST_BILLABLE_METRIC'
  | 'TEST_PRICING_RATE_CARD'
  | 'TEST_CHANGE_MANAGEMENT_RATE_CARD'
  | unhandledEnumCase;

export type FeatureGroup =
  | 'BREEZE_AGENTS'
  | 'BREEZE_INTELLIGENCE'
  | 'BREEZE_AUTOMATION'
  | 'AUTOMATION'
  | 'BUYER_INTENT'
  | 'DATA_STUDIO'
  | 'MESSAGING'
  | 'CPQ'
  | 'CALLING'
  | 'EVENTS'
  | 'AEO'
  | 'WORK_MANAGEMENT'
  | 'TEST_FEATURE_GROUP'
  | unhandledEnumCase;

export namespace ComHubspotUsagebasedbillingCommonsModels {
  export type FeatureType =
    | 'CUSTOMER_AGENT'
    | 'ENRICHMENT'
    | 'PROSPECTING_AGENT'
    | 'DATA_AGENT'
    | 'CLOSING_AGENT'
    | 'WORKFLOWS'
    | 'INTENT'
    | 'DATA_STUDIO_SYNC'
    | 'EMAIL_SEND'
    | 'WHATSAPP'
    | 'QUOTES_ACCEPTED'
    | 'CALLING_MINUTES'
    | 'WORKFLOWS_NON_AI_EXECUTIONS'
    | 'UNIFIED_EVENTS'
    | 'CUSTOM_EVENTS'
    | 'CONTENT_AGENT'
    | 'KNOWLEDGE_BASE_AGENT'
    | 'CUSTOM_AGENT'
    | 'ANSWERS'
    | 'NURTURE_AGENT'
    | 'CAMPAIGN_AGENT'
    | 'REVENUE_AGENT'
    | 'HUBSPOT_WORK_AGENT'
    | 'CONVERSATIONAL_CONTEXT'
    | 'TEST_FEATURE_TYPE'
    | unhandledEnumCase;
}

export type McpServerVisibility =
  | 'INSTALL_REQUIRED'
  | 'GLOBALLY_VISIBLE'
  | unhandledEnumCase;

export type DayOfWeek =
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | unhandledEnumCase;

export type ChronoUnit =
  | 'NANOS'
  | 'MICROS'
  | 'MILLIS'
  | 'SECONDS'
  | 'MINUTES'
  | 'HOURS'
  | 'HALF_DAYS'
  | 'DAYS'
  | 'WEEKS'
  | 'MONTHS'
  | 'YEARS'
  | 'DECADES'
  | 'CENTURIES'
  | 'MILLENNIA'
  | 'ERAS'
  | 'FOREVER'
  | unhandledEnumCase;

export type GetDetailsResponseType = EditorDetailsResponse;
export type GetDetailsErrorType = EditorDetailsError & HubspotMetadata;
export const getDetailsRpc: ChirpAvroRpcDetails<
  undefined,
  GetDetailsResponseType,
  GetDetailsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc',
  rpcName: 'getDetails',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA8SC3_IZFHaJ-gTPRevjAZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetListingSummariesRequestType =
  Requestify<GetListingSummariesRequest>;
export type GetListingSummariesResponseType = EditorListingSummaryResponse;
export type GetListingSummariesErrorType = EditorDetailsError & HubspotMetadata;
export const getListingSummariesRpc: ChirpAvroRpcDetails<
  GetListingSummariesRequestType,
  GetListingSummariesResponseType,
  GetListingSummariesErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc',
  rpcName: 'getListingSummaries',
  auth: 'app',
  fingerprint: 'xySVIHl1J0Ckol1aaljrRZ-gTPRevjAZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetListingSummariesPageRequestType =
  Requestify<GetListingSummariesPageRequest>;
export type GetListingSummariesPageResponseType =
  EditorListingSummaryPageResponse;
export type GetListingSummariesPageErrorType = EditorDetailsError &
  HubspotMetadata;
export const getListingSummariesPageRpc: ChirpAvroRpcDetails<
  GetListingSummariesPageRequestType,
  GetListingSummariesPageResponseType,
  GetListingSummariesPageErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc',
  rpcName: 'getListingSummariesPage',
  auth: 'app',
  fingerprint: 'RrydEG-s9MKeWpwd5nvH8p-gTPRevjAZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetDraftListingRequestType = Requestify<DraftListingRequest>;
export type GetDraftListingResponseType = ListingDetailsResponseV3;
export type GetDraftListingErrorType = EditorDetailsError & HubspotMetadata;
export const getDraftListingRpc: ChirpAvroRpcDetails<
  GetDraftListingRequestType,
  GetDraftListingResponseType,
  GetDraftListingErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc',
  rpcName: 'getDraftListing',
  auth: 'app',
  fingerprint: 'psOLGDKotUqjfkJwW1qLGp-gTPRevjAZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
